/**
 * KeypadHeader.js
 * Talkroute
 *
 * Created by Vel Genov on 1/6/20
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import { connect } from "react-redux";

import { domIds } from "../../constants/testConstants";

import uiString from "../../constants/uiString";
import { setOutgoingPhoneNumber } from "../../actions/callActions";
import { CallStateEnum } from "../../constants/callConstants";
import validateArray from "../../helpers/arrayValidator";
import DropdownComponent from "../PresentationComponents/DropdownComponent";

interface IKeypadHeaderProps {
  outgoingPhoneNumbers: any[];
  selectedOutgoingPhoneNumber: string;
  callState: string;
  defaultOutgoingPhoneNumber: string;
  setOutgoingPhoneNumber: (number: string) => any;
}

class KeypadHeader extends React.Component<IKeypadHeaderProps, any> {
  static defaultProps = {
    outgoingPhoneNumbers: [],
    callState: CallStateEnum.IDLE,
  };

  /**
   * Update the outgoing phone number for calling
   */
  updateOutgoingPhoneNumber = (name: string | undefined, newPhoneNumber: unknown) => {
    const { setOutgoingPhoneNumber: setOutgoingPhoneNumberLocal } = this.props;

    setOutgoingPhoneNumberLocal(newPhoneNumber as string);
  };

  /**
   * Shows dropdown of outgoing phone numbers for calling
   */
  showPhoneNumberDropdown = (prefs) => {
    const { callState } = this.props;
    const { phoneNumbers, label, selectedValue, name } = prefs;
    let placeholderValue = uiString.SELECT_PHONE_NUMBER;
    const dropdownLabel = `${label} `;
    let dropdownOptions: any = [];
    const { defaultOutgoingPhoneNumber } = this.props

    if (validateArray(phoneNumbers)) {
      dropdownOptions = phoneNumbers.map((entry) => ({
        value: entry.getPhoneNumber(),
        text: entry.getPhoneNumberFormatted(),
      }));
    } else {
      // Add "None" as an option only if there are no other phone numbers
      dropdownOptions.push({
        value: null,
        text: uiString.preferences.OUTGOING_NONE,
      });

      placeholderValue = uiString.preferences.OUTGOING_NONE;
    }

    let disabled = false;
    if (callState !== CallStateEnum.IDLE) disabled = true;

    return (
      <div
        className="none-select-text"
        style={{ padding: "17px 0 10px 0", fontSize: "22px" }}
      >
        {dropdownLabel} {' '}
        <DropdownComponent
          id={domIds.KEYPAD_HEADER_FROM_PHONE_DROPDOWN}
          className="text-normal"
          wrapperStyles={{display: "contents"}}
          disabled={disabled}
          value={selectedValue}
          name={name}
          placeholder={placeholderValue}
          options={dropdownOptions}
          onChange={e => this.updateOutgoingPhoneNumber(e.target.name, e.target.value)}
          dropdownStyle={{ fontSize: "22px" }}
          boldColor
        />
      </div>
    );
  };

  componentDidUpdate(prevProps) {
    const {
      selectedOutgoingPhoneNumber: prevSelectedOutgoingPhoneNumber,
      callState: prevCallState,
    } = prevProps;
    const {
      selectedOutgoingPhoneNumber,
      callState,
      defaultOutgoingPhoneNumber,
    } = this.props;

    if (
      prevSelectedOutgoingPhoneNumber !== selectedOutgoingPhoneNumber &&
      callState === CallStateEnum.IDLE
    ) {
      this.updateOutgoingPhoneNumber('', selectedOutgoingPhoneNumber);
    }

    if (
      prevCallState !== callState &&
      callState === CallStateEnum.IDLE &&
      selectedOutgoingPhoneNumber !== defaultOutgoingPhoneNumber
    ) {
      this.updateOutgoingPhoneNumber('', selectedOutgoingPhoneNumber);
    }
  }

  render() {
    const { outgoingPhoneNumbers, defaultOutgoingPhoneNumber } = this.props;

    return this.showPhoneNumberDropdown({
      phoneNumbers: outgoingPhoneNumbers,
      label: uiString.CALL_FROM,
      selectedValue: defaultOutgoingPhoneNumber,
      name: "Outgoing_phone_number_selector",
    });
  }
}

// Redux data binding
const mapStateToProps = (state) => ({
  outgoingPhoneNumbers: state.preferences.outgoingPhoneNumbers,
  selectedOutgoingPhoneNumber: state.preferences.selectedOutgoingPhoneNumber,
  defaultOutgoingPhoneNumber: state.callReducer.defaultOutgoingPhoneNumber,
  callState: state.callReducer.callState,
});

export default connect(mapStateToProps, { setOutgoingPhoneNumber })(
  KeypadHeader
);
